module.exports = __webpack_public_path__ + "img/img4.ce6f996f.jpg";